import debounce from "lodash.debounce";
import { useSelector } from "react-redux";
import { ROUTES } from "routes/routePaths";
import React, { useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { TextField, Typography } from "components";
import exportCTA from "assets/images/export-cta.svg";
import terminalFilterCTA from "assets/images/terminal-filter-cta.svg";
import {
  setTransactionQuery,
  getTransactionDetails,
} from "redux/actions/transactionActions";

const TransactionTableHeader = ({
  isDashboardTransactions,
  setIsDownloadVisible,
  setIsFilterVisible,
}) => {
  const navigate = useNavigate();

  const { searchValue, transactionDetails } = useSelector((state) => ({
    searchValue: state.transactionsReducer.params.searchValue,
    transactionDetails:
      state.transactionsReducer.transactions?.content?.content,
  }));

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const loadWithDebounce = useCallback(
    debounce(() => {
      getTransactionDetails();
    }, 1000),
    []
  );

  const handleSearch = (e) => {
    let value = e.target.value;
    setTransactionQuery({
      name: "searchValue",
      value,
    });

    if (value.length > 3 || !value.length) {
      loadWithDebounce(value);
    }
  };

  return (
    <div>
      {isDashboardTransactions ? (
        <div className="d-flex justify-content-between align-items-center mb-2">
          <Typography state="primary" variant="caption2">
            Recent Transactions
          </Typography>
          <Typography
            state="primary"
            variant="caption2"
            className={"cursor-pointer"}
            onClick={() => navigate(ROUTES.transactions)}
          >
            View All
          </Typography>
        </div>
      ) : (
        <div className="mt-4 mb-3">
          <Typography variant="subtitle3" state="primary">
            Terminal Transactions
          </Typography>
          <div className="mt-2 d-flex transactions-header">
            <img
              src={terminalFilterCTA}
              alt=""
              width="110"
              className="cursor-pointer filter"
              onClick={() => setIsFilterVisible(true)}
            />
            <div className="transaction-header-right align-items-start">
              <div>
                <TextField
                  searchField
                  className={"transaction-search"}
                  placeholder={"Search by RRN, Terminal ID, Serial No or STAN"}
                  onChange={handleSearch}
                  name="searchValue"
                  value={searchValue}
                />
                <Typography variant="caption0" className={"text-center"}>
                  Minimum of four(4) Characters
                </Typography>
              </div>
              &nbsp; &nbsp;
              {transactionDetails?.length ? (
                <img
                  src={exportCTA}
                  alt=""
                  width="110"
                  className="cursor-pointer"
                  onClick={() => setIsDownloadVisible(true)}
                />
              ) : (
                ""
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default TransactionTableHeader;
